import { defineComponent } from 'vue';
import ProcessorComponent from '@/components/ProcessorComponent.vue';
export default defineComponent({
    name: 'Processor',
    components: { ProcessorComponent },
    data() {
        return {};
    }
});
